/**
 * Browser stand-in for `node:crypto`. jkurwa's published bundle bakes in the
 * Node RNG (`crypto.rng`), which does not exist in a browser; the bundler
 * aliases both `crypto` and `node:crypto` here — see tools/vite/aliases.mjs.
 *
 * Aliased by path, so this file has no barrel and is never imported by name.
 */
import { Buffer } from "buffer";

export const rng = (size: number): Buffer => {
  const bytes = new Uint8Array(size);

  globalThis.crypto.getRandomValues(bytes);

  return Buffer.from(bytes);
};

export const randomBytes = (size: number): Buffer => rng(size);

export default { rng, randomBytes };
